var _rect, _path, _path2, _g, _use, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "Amazon Simple Storage Service",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e05243",
    d: "M260 348l-137 33V131l137 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c3123",
    d: "M256 349l133 32V131l-133 32v186"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e05243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M256 64v97l58 14V93zm133 67v250l26-13V143zm-133 77v97l58-8v-82zm58 129l-58 14v97l58-29z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#8c3123",
    transform: "rotate(180 256 256)",
    xlinkHref: "#a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e1f18",
    d: "M314 175l-58 11-58-11 58-15 58 15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2b0a9",
    d: "M314 337l-58-11-58 11 58 16 58-16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.e556dc313d5176e93d1286f719841d46.svg";
export { ForwardRef as ReactComponent };